var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdhesive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "484px",
    height: "534px",
    viewBox: "0 0 484 534",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy 3@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.69134,194.587369 L313.544375,134.275549 C315.651832,133.613039 317.897334,134.7844 318.559844,136.891857 C318.803541,137.66706 318.805353,138.4981 318.565042,139.274358 L259.382561,330.446407 C258.604377,332.96011 256.639807,334.930382 254.12837,335.715849 L62.3899102,395.683205 C60.281485,396.342628 58.037701,395.167979 57.3782783,393.059554 C57.1363197,392.28592 57.1351127,391.457031 57.3748175,390.682696 L116.448297,199.853411 C117.225233,197.343618 119.184971,195.375283 121.69134,194.587369 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.2%",
    y: "-23.5%",
    width: "148.5%",
    height: "148.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.414089816 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy-3",
    transform: "translate(43.876682, 2.011867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.69134,271.587369 L314.544375,211.275549 C316.651832,210.613039 318.897334,211.7844 319.559844,213.891857 C319.803541,214.66706 319.805353,215.4981 319.565042,216.274358 L260.382561,407.446407 C259.604377,409.96011 257.639807,411.930382 255.12837,412.715849 L63.3899102,472.683205 C61.281485,473.342628 59.037701,472.167979 58.3782783,470.059554 C58.1363197,469.28592 58.1351127,468.457031 58.3748175,467.682696 L117.448297,276.853411 C118.225233,274.343618 120.184971,272.375283 122.69134,271.587369 Z",
    id: "Rectangle",
    stroke: "#FFC48B",
    strokeWidth: 6,
    transform: "translate(188.972004, 341.972004) rotate(45.000000) translate(-188.972004, -341.972004) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(187.972004, 264.972004) rotate(45.000000) translate(-187.972004, -264.972004) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#49D2F3",
    strokeWidth: 6,
    fill: "#4AD5F6",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.69134,117.587369 L313.544375,57.2755491 C315.651832,56.613039 317.897334,57.7844 318.559844,59.8918571 C318.803541,60.66706 318.805353,61.4980997 318.565042,62.2743584 L259.382561,253.446407 C258.604377,255.96011 256.639807,257.930382 254.12837,258.715849 L62.3899102,318.683205 C60.281485,319.342628 58.037701,318.167979 57.3782783,316.059554 C57.1363197,315.28592 57.1351127,314.457031 57.3748175,313.682696 L116.448297,122.853411 C117.225233,120.343618 119.184971,118.375283 121.69134,117.587369 Z",
    id: "Rectangle",
    stroke: "#95CDB1",
    strokeWidth: 6,
    transform: "translate(187.972004, 187.972004) rotate(45.000000) translate(-187.972004, -187.972004) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhesive);
export default __webpack_public_path__ + "static/media/adhesive.78f9db74b2e82bd98e99e132b01a06ff.svg";
export { ForwardRef as ReactComponent };